/*
 * XCS Automotive – indicatief inkoopbod ("Wij kopen uw wagen")
 * Referentie-implementatie bij prijstabel.json v1.1 (engine "xcs_p25_v1", pricing.formula "margin_scheme").
 * Pure functie, geen dependencies, werkt in browser en Node.
 *
 *   inkoopschatting(table, input, opts?) -> result
 *     table : geparste prijstabel.json
 *     input : zie README.md (§3). Ontbrekende velden verlagen het bod altijd.
 *     opts  : { refDate?: Date }   standaard vandaag
 *   result  : { status:'ok', range:[laag,hoog], mid, retailEstimate, baseOffer, steps[], flags[], ... }
 *          of { status:'no_match', reason, message, steps[], flags[] }
 */
(function (root) {
  'use strict';
  function n(s) { return (s == null ? '' : String(s)).trim().toLowerCase(); }
  function isNum(x) { return typeof x === 'number' && isFinite(x); }
  function floorTo(x, step) { return Math.floor(x / step) * step; }
  function val(map, key) {               // keuze -> waarde; onbekend/ongeldig -> 'unknown'
    var k = n(key);
    return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : map.unknown;
  }
  var FUEL_ALIAS = { benzine: 'petrol', essence: 'petrol', petrol: 'petrol', diesel: 'diesel',
    hybride: 'hybrid', hybrid: 'hybrid', phev: 'hybrid', 'plug-in hybride': 'hybrid',
    elektrisch: 'electric', electric: 'electric', ev: 'electric', 'électrique': 'electric' };

  function candidates(table, input) {
    var id = n(input.modelId), mk = n(input.make), md = n(input.model), out = [];
    for (var i = 0; i < table.models.length; i++) {
      var m = table.models[i];
      if (id ? n(m.id) === id : (n(m.make) === mk && n(m.model) === md)) out.push(m);
    }
    return out;
  }
  function yr(m, Y) { var ys = m.xcs.years; for (var i = 0; i < ys.length; i++) if (ys[i][0] === Y) return ys[i]; return null; }

  // P25-retailschatting incl. btw voor één model/brandstof-entry
  function retail(table, m, Y, age, km, auto, hp, steps) {
    var th = table.thresholds, x = m.xcs;
    if (m.n_comps < th.min_comps_model_fuel) return { err: 'too_few_comps' };
    var win = 0; for (var d = -1; d <= 1; d++) { var r = yr(m, Y + d); if (r) win += r[1]; }
    if (win < th.min_comps_year_window) return { err: 'too_few_comps_year' };
    var pm;
    if (x.power) {
      if (isNum(hp)) pm = x.power.mult[hp < x.power.cutsHp[0] ? 0 : (hp < x.power.cutsHp[1] ? 1 : 2)];
      else { pm = x.power.mult[0]; steps.push('versie/vermogen onbekend → laagste versie ×' + pm); }
    } else { pm = 0.95; if (!isNum(hp)) steps.push('versie onbekend, geen vermogensklassen ×0.95'); else pm = 1; }
    var R = Math.exp(x.c - x.a * age - x.k * km / 10000 + x.g * auto) * pm;
    var row = yr(m, Y);
    if (row && row[3] != null && row[1] >= th.min_comps_year_window) {
      var emp = row[3] * Math.exp(-x.k * (km - row[2]) / 10000) * Math.exp(x.g * auto) * pm;
      if (emp < R) { R = emp; steps.push('cap: goedkoopste kwart bouwjaar ' + Y); }
    }
    return { retail: R };
  }

  function inkoopschatting(table, input, opts) {
    input = input || {}; opts = opts || {};
    var th = table.thresholds, of = table.pricing, adj = table.adjustments, steps = [], flags = [];
    function noMatch(reason) { return { status: 'no_match', reason: reason, message: table.messages.no_match, steps: steps, flags: flags }; }

    // 1. harde uitsluitingen (geen bedrag) ---------------------------------------
    var exterior = n(input.exterior) || 'unknown';
    if (exterior === 'unknown') steps.push('staat niet gekozen → "used" (0.92)');
    var mult = [['exterior', val(adj.exterior, exterior)], ['interior', val(adj.interior, input.interior)],
      ['accident', val(adj.accident, input.accident)], ['warning_lights', val(adj.warning_lights, input.warning_lights)],
      ['financing', val(adj.financing, input.financing)]];
    for (var i = 0; i < mult.length; i++) if (mult[i][1] === null) return noMatch(mult[i][0] + ':' + n(input[mult[i][0]] || 'unknown'));

    var cands = candidates(table, input);
    if (!cands.length) return noMatch('model_not_in_table');

    var year = parseInt(input.year, 10);
    if (!isNum(year)) return noMatch('year_missing');
    var month = parseInt(input.month, 10);
    if (!(month >= 1 && month <= 12)) { month = table.unknown_defaults.month; steps.push('maand onbekend → januari'); }
    var ref = opts.refDate || new Date();
    var age = ref.getFullYear() + (ref.getMonth() + (ref.getDate() - 1) / 31) / 12 - (year + (month - 0.5) / 12);
    if (age > th.max_age_years) return noMatch('age_over_' + th.max_age_years);
    if (age < 0) return noMatch('year_in_future');
    var km = Number(input.km);
    if (input.km == null || !isNum(km) || km < 0) return noMatch('km_missing');
    if (km > th.max_km) return noMatch('km_over_' + th.max_km);

    var gb = n(input.gearbox), auto = (gb === 'automatic' || gb === 'automaat') ? 1 : 0;
    var gbUnknown = (gb !== 'automatic' && gb !== 'automaat' && gb !== 'manual' && gb !== 'manueel');
    var hp = isNum(input.power_hp) ? input.power_hp : null;

    // 2. retailschatting: gekozen brandstof, of laagste brandstof indien onbekend ------
    var fuel = FUEL_ALIAS[n(input.fuel)] || null, best = null;
    for (var j = 0; j < cands.length; j++) {
      var m = cands[j];
      if (fuel && m.fuel !== fuel) continue;
      var st = [], r = retail(table, m, year, age, km, m.fuel === 'electric' ? 1 : auto, hp, st);
      if (r.err) { if (fuel) return noMatch(r.err); continue; }
      if (!best || r.retail < best.retail) best = { retail: r.retail, m: m, st: st };
    }
    if (!best) return noMatch(fuel ? 'fuel_not_in_table' : 'too_few_comps');
    if (!fuel) steps.push('brandstof onbekend → laagste groep (' + best.m.fuel + ')');
    if (gbUnknown && best.m.fuel !== 'electric') steps.push('versnellingsbak onbekend → manueel');
    steps = steps.concat(best.st);
    var R = best.retail;
    if (R > th.max_value_eur) return noMatch('value_over_' + th.max_value_eur);

    // 3. basisbod (particulier / margewagen) ---------------------------------------
    var cost = null;
    for (var t = 0; t < of.cost_tiers.length; t++) if (of.cost_tiers[t].retail_below == null || R < of.cost_tiers[t].retail_below) { cost = of.cost_tiers[t].cost; break; }
    var keep = 1 - of.margin_target, base;
    if (of.formula === 'margin_scheme') {
      // margeregeling: winst = (R − bod)/(1+btw) − kosten = margin_target × R/(1+btw)
      base = keep * R - of.cost_multiplier * cost;
      steps.push('retail P25 €' + Math.round(R) + ' → ' + keep + '×' + Math.round(R) + ' − ' + of.cost_multiplier + '×' + cost + ' = €' + Math.round(base));
    } else if (of.formula === 'full_vat') {
      base = R / (1 + of.vat_rate) * keep - cost;
      steps.push('retail P25 €' + Math.round(R) + ' → ' + Math.round(R) + '/' + (1 + of.vat_rate) + '×' + keep + ' − ' + cost + ' = €' + Math.round(base));
    } else return noMatch('unknown_pricing_formula');
    var mid = base;

    // 4. multiplicatoren (allemaal ≤ 1) -------------------------------------------
    var col = n(input.colour), colF = !col ? adj.colour.unknown : (adj.colour.penalised_colours.indexOf(col) >= 0 ? adj.colour.penalised : adj.colour.normal);
    var docsOk = input.vin_provided === true && input.registration_doc_provided === true;
    var photos = isNum(input.photos) ? input.photos : 0;
    mult = mult.slice(0, 5).concat([['colour', colF], ['documents', docsOk ? adj.documents.complete : adj.documents.missing],
      ['photos', photos >= adj.photos.min ? adj.photos.enough : adj.photos.too_few]]);
    for (i = 0; i < mult.length; i++) if (mult[i][1] !== 1) { mid *= mult[i][1]; steps.push(mult[i][0] + ' ×' + mult[i][1]); }

    // 5. vaste aftrekken -----------------------------------------------------------
    var keysKey = input.keys == null ? 'unknown' : (Number(input.keys) >= 3 ? '3plus' : String(Math.max(0, Number(input.keys) | 0)));
    var adds = [['service_book', val(adj.service_book, input.service_book)], ['inspection', val(adj.inspection, input.inspection)], ['keys', val(adj.keys, keysKey)]];
    for (i = 0; i < adds.length; i++) if (adds[i][1].value) { mid += adds[i][1].value; steps.push(adds[i][0] + ' ' + adds[i][1].value); }

    // 6. flags (geen bedrag) -----------------------------------------------------
    var fin = n(input.financing) || 'unknown';
    if (table.flags.financing[fin]) flags.push(table.flags.financing[fin]);
    if (n(input.vat_car) === 'vat') flags.push(table.flags.vat_car.vat);

    if (mid < th.min_offer_eur) return noMatch('offer_below_minimum');
    var f = table.formula;
    var lo = floorTo(mid * f.range_low_factor, f.round_to), hi = floorTo(mid * f.range_high_factor, f.round_to);
    return { status: 'ok', range: [lo, hi], mid: Math.round(mid), baseOffer: Math.round(base), retailEstimate: Math.round(R),
      modelId: best.m.id, fuelUsed: best.m.fuel, ageYears: Math.round(age * 100) / 100, steps: steps, flags: flags };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = inkoopschatting;
  else root.inkoopschatting = inkoopschatting;
})(this);
